/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import { decode } from 'he';

const getTag = (documentTypes) => <span className="deepsea-tag">{documentTypes[0].name}</span>;

const Result = ({ entry }) => (
  <div className="wp-block-deepsea-column col-desk-4 col-tab-6 col-mob-12">
    <article class="card-item" role="article" aria-label={decode(entry.title)}>
      <div className="card-item-content">
        {entry.subtype && <div className="card-itemTags">{getTag(entry.document_type)}</div>}
        {entry.subtype !== 'people' && (
          <h3 class="card-itemTitle">
            <a href={entry.url}>{decode(entry.title)}</a>
          </h3>
        )}
        {entry.subtype === 'people' && (
          <h3 class="card-itemTitle">
            <span>{decode(entry.title)}</span>
          </h3>
        )}
        {entry.download_url !== '' && entry.document_type[0].slug !== 'loan-enquiries' && (
          <div className="card-itemButton button-wrapper">
            <a href={entry.download_url} download class="btn btn--subtle icon-download">
              Download
            </a>
          </div>
        )}
        {entry.document_type[0].slug === 'loan-enquiries' && (
          <div className="card-itemButton button-wrapper">
            <a href={entry.download_url} target="_blank" class="btn btn--text">
              Make an enquiry
            </a>
          </div>
        )}
      </div>
    </article>
  </div>
);

export default Result;
